import { render, staticRenderFns } from "./InvTransView.vue?vue&type=template&id=55339b94&scoped=true&"
import script from "./InvTransView.vue?vue&type=script&lang=js&"
export * from "./InvTransView.vue?vue&type=script&lang=js&"
import style0 from "./InvTransView.vue?vue&type=style&index=0&id=55339b94&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55339b94",
  null
  
)

export default component.exports